export const checkIsReady = (query) =>
  !query.isLoading &&
  !query.isFetching &&
  !query.isError &&
  !query.isUninitialized;
